module.exports = __webpack_public_path__ + "static/media/SINGLE BREASTED 4 BUTTONS.0ac37cc6.svg";